module.exports = __webpack_public_path__ + "static/media/weatherapp.88db1766.png";